import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";
import {
  MessageTemplateApiMessageTemplateListRequest,
  PageModel
} from "../../../proto/generated/api_entities_pb";
import {InitialPage} from "../../constans/pagination/pagination";
import {PageModelLimits} from "../../constans/pagination/pageModelLimits";
import {API} from "../../../API/API";

export interface IMessageTemplateOption extends DebounceSelectOptionProps {
  text?: string;
}

export async function fetchMessageTemplates(search?: string): Promise<IMessageTemplateOption[]> {
  const req = new MessageTemplateApiMessageTemplateListRequest()
    .setPagemodel(
      new PageModel().setPage(InitialPage).setLimit(PageModelLimits.Notifications)
    );

  if (search) {
    req.setName(search);
  }

  const templatesList = await API.messageTemplateList(req);

  return templatesList.getMessagetemplatesList().map(template => {
    return {
      key: template.getMessagetemplateid(),
      label: template.getName(),
      value: template.getMessagetemplateid(),
      text: template.getText(),
    }
  })
}

